import classNames from "classnames/bind";
import React from "react";
import styles from "./Button.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  type?: string;
  textSize?: "small" | "large";
  bold?: boolean;
  noUnderline?: boolean;
  kind?: "primary" | "secondary" | "disabled";
  spacing?: boolean;
}

export const TextButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  kind = "primary",
  textSize = "small",
  bold,
  noUnderline,
  onClick = undefined,
  spacing = true,
}) => {
  const classes = classNameBuilder({
    button: true,
    simple: true,
    simplePrimary: kind === "primary",
    simpleSecondary: kind === "secondary",
    disabledTextButton: kind === "disabled",
    smallText: textSize === "small",
    largeText: textSize === "large",
    noSpacing: !spacing,
    bold: bold,
    noUnderline: noUnderline,
  });

  return (
    <button className={classes} onClick={onClick} type="button">
      {children}
    </button>
  );
};
